export default "__VITE_ASSET__2abdaffa__"